module.exports = __webpack_public_path__ + "img/logo-soluções-negativo.9918c0c9.png";